export default __webpack_public_path__ + "static/media/bmFaq.803d93b0.pdf";